import { supabase } from '../../supabase';
import { v4 as uuidv4 } from 'uuid';
import { isGoogleDriveUrl, extractGoogleDriveFileId, convertGoogleDriveUrl } from '@/utils/image-utils';

export async function processExternalImage(url: string, creatorId: string): Promise<string> {
  try {
    console.log(`Processing external image: ${url}`);
    
    if (!isGoogleDriveUrl(url)) {
      console.log('Not a Google Drive URL, returning as-is');
      return url; // not a Google Drive link, use as-is
    }

    const fileId = extractGoogleDriveFileId(url);
    if (!fileId) {
      console.warn('Could not extract file ID from Google Drive URL');
      return url;
    }

    console.log(`Extracted file ID: ${fileId}`);
    const downloadUrl = convertGoogleDriveUrl(url);
    console.log(`Download URL: ${downloadUrl}`);

    // Fetch with no-cors to avoid CORS issues
    const response = await fetch(downloadUrl, {
      headers: {
        'Accept': 'image/*'
      }
    });

    if (!response.ok) {
      console.error(`Failed to fetch image: ${response.status} ${response.statusText}`);
      return url;
    }

    const contentType = response.headers.get('content-type') || '';
    console.log(`Content type: ${contentType}`);

    if (!contentType.startsWith('image/')) {
      console.warn(`Unsupported content type: ${contentType}`);
      return url;
    }

    const blob = await response.blob();
    console.log(`Got blob of size: ${blob.size} bytes`);
    
    if (blob.size === 0) {
      console.warn('Received empty blob');
      return url;
    }

    const extension = contentType.split('/')[1] || 'jpg';
    const filename = `firesnap-${uuidv4()}.${extension}`;
    const filePath = `${creatorId}/${filename}`;

    console.log(`Uploading to Supabase: ${filePath}`);
    const { data, error: uploadError } = await supabase.storage
      .from('snap-images')
      .upload(filePath, blob, {
        contentType,
        cacheControl: '3600',
        upsert: true
      });

    if (uploadError) {
      console.error('Upload to Supabase failed:', uploadError);
      return url;
    }

    console.log('Upload successful, getting public URL');
    const { data: publicUrlData } = supabase.storage
      .from('snap-images')
      .getPublicUrl(filePath);

    const publicUrl = publicUrlData?.publicUrl || url;
    console.log(`Public URL: ${publicUrl}`);
    
    return publicUrl;
  } catch (err) {
    console.error('processExternalImage failed:', err);
    return url;
  }
}